// extracted by mini-css-extract-plugin
export var chip = "_c3-0";
export var filterDropdown = "_c3-5";
export var filterItem = "_c3-6";
export var icon = "_c3-1";
export var removeButton = "_c3-3";
export var removeIcon = "_c3-4";
export var separator = "_c3-2";